import { Button, Section } from '@memorizecards/ui';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function NaoEncontrado(): ReactNode {
  return (
    <Section spacing="lg" width="reading">
      <div className="text-center">
        <p className="mc-mono mc-eyebrow mb-4 justify-center">Erro 404</p>
        <h1 className="text-mc-h2">Esta página não existe</h1>
        <p className="mx-auto mt-4 max-w-md text-mc-body text-mc-ink2">
          O endereço pode ter mudado ou o link estar incompleto.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/baralhos">
            <Button>Ir para os flashcards</Button>
          </Link>
          <Link to="/desempenho">
            <Button variant="ghost">Ver meu desempenho</Button>
          </Link>
        </div>
      </div>
    </Section>
  );
}
